import { AuthTokenStorage } from "../AuthTokenStorage";

export const UseLogout = (): void => {
    AuthTokenStorage.clear();
    window.location.href = "/";
};
